import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Message } from 'semantic-ui-react';

class GranteeCalendarSaved extends Component {
  showTabsAgain = () => {
    this.props.showTabsAgain();
  };

  renderSavedDetails() {
    let { showSaveMessage } = this.props;
    return showSaveMessage ? (
      <div>
        <Message
          header="The changes you have made have been saved."
          content="You can still make changes to your unavailabilty if needed. If you would like to view and edit your unavailability now please click the View Unavailability button below."
        />
        <Button color="blue" onClick={this.showTabsAgain}>
          View Unavailability
        </Button>
      </div>
    ) : (
      <div></div>
    );
  }

  render() {
    return <div> {this.renderSavedDetails()} </div>;
  }
}

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, {})(GranteeCalendarSaved);
